import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noPreviewTitle: {
    id: 'noPreview.title',
    defaultMessage: 'No preview available',
  },
  notFoundTitle: {
    id: 'notFound.title',
    defaultMessage: 'Page not found!',
  },
  serverErrorTitle: {
    id: 'serverError.title',
    defaultMessage: 'Oops. Something went wrong',
  },
});
